export default __webpack_public_path__ + "static/media/sf-logo.66534dbe.svg";